import JavaLog from './JavaLog.vue';
export default JavaLog;
